import script from "./FoodLogEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodLogEntry.vue?vue&type=script&setup=true&lang=js"

import "./FoodLogEntry.vue?vue&type=style&index=0&id=1b5f0f90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5f0f90"]])

export default __exports__